import type React from "react"
import { createContext, useContext } from "react"
import { Outlet } from "react-router-dom"
import { Sidebar } from "./sidebar"

interface DashboardLayoutProps {
  children?: React.ReactNode
}

const DashboardLayoutContext = createContext(false)

export function DashboardLayout({ children }: DashboardLayoutProps) {
  const isNested = useContext(DashboardLayoutContext)
  if (isNested) {
    return <>{children ?? <Outlet />}</>
  }

  return (
    <DashboardLayoutContext.Provider value={true}>
      <div className="min-h-screen" style={{ background: "linear-gradient(180deg, #E4FFE5 35.1%, #F4FFF4 100%)" }}>
        <Sidebar />
        <div className="lg:pl-64">
          <main className="py-6 px-4 lg:px-8">{children ?? <Outlet />}</main>
        </div>
      </div>
    </DashboardLayoutContext.Provider>
  )
}
